<section
  class="manage-list-skeleton-container"
  [ngClass]="
    platform === PlatformEnum.tablet
      ? 'tablet'
      : platform === PlatformEnum.mobile
      ? 'mobile'
      : 'desktop'
  "
>
  <ng-container
    *ngIf="platform === PlatformEnum.desktop"
    [ngTemplateOutlet]="desktopHeader"
  ></ng-container>

  <ng-container
    *ngIf="platform === PlatformEnum.tablet"
    [ngTemplateOutlet]="tabletHeader"
  ></ng-container>

  <ng-container
    *ngIf="platform === PlatformEnum.mobile"
    [ngTemplateOutlet]="mobileHeader"
  ></ng-container>

  <div class="item-container horizontal-flex">
    <div class="container-left">
      <ion-skeleton-text
        class="group-name"
        [ngClass]="platform === PlatformEnum.mobile ? 'mobile' : ''"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
    </div>
    <div *ngIf="platform !== PlatformEnum.mobile" class="container-right">
      <ion-skeleton-text class="add-prod-button" animated></ion-skeleton-text>
      <div class="horizontal-flex">
        <ion-skeleton-text class="groups-label" animated></ion-skeleton-text>
        <ion-skeleton-text
          class="add-group-button"
          animated
        ></ion-skeleton-text>
      </div>
      <ion-skeleton-text class="group-icon" animated></ion-skeleton-text>
      <ion-skeleton-text class="group-icon" animated></ion-skeleton-text>
    </div>
  </div>
</section>

<ng-template #desktopHeader>
  <div class="main-header">
    <div class="crumb-header horizontal-flex">
      <ion-skeleton-text class="breadcrumbs" animated></ion-skeleton-text>
      <ion-skeleton-text class="print-options" animated></ion-skeleton-text>
    </div>
    <ion-skeleton-text class="title" animated></ion-skeleton-text>
    <div class="horizontal-flex">
      <ion-skeleton-text class="list-name" animated></ion-skeleton-text>
      <ion-skeleton-text class="ellipsis-button" animated></ion-skeleton-text>
    </div>
    <ion-skeleton-text class="search" animated></ion-skeleton-text>
  </div>
</ng-template>

<ng-template #tabletHeader>
  <div class="main-header">
    <div class="crumb-header horizontal-flex">
      <ion-skeleton-text class="title" animated></ion-skeleton-text>
      <div class="sub-header">
        <ion-skeleton-text class="print-options" animated></ion-skeleton-text>
        <ion-skeleton-text class="ellipsis-button" animated></ion-skeleton-text>
      </div>
    </div>
    <ion-skeleton-text class="list-name" animated></ion-skeleton-text>
    <ion-skeleton-text class="search" animated></ion-skeleton-text>
  </div>
</ng-template>

<ng-template #mobileHeader>
  <div class="main-header">
    <div class="crumb-header horizontal-flex space-between mobile">
      <ion-skeleton-text class="mobile-button" animated></ion-skeleton-text>
      <ion-skeleton-text class="mobile-button" animated></ion-skeleton-text>
      <ion-skeleton-text class="mobile-button" animated></ion-skeleton-text>
    </div>
    <div class="horizontal-flex mobile">
      <ion-skeleton-text class="group-name" animated></ion-skeleton-text>
      <ion-skeleton-text
        class="ellipsis-button mobile"
        animated
      ></ion-skeleton-text>
    </div>

    <ion-skeleton-text class="search mobile" animated></ion-skeleton-text>
  </div>
</ng-template>
